export default () => document.getElementById('modal-root');
